import React from 'react';

export default function SelectAllButton({ section, onClick, disabled = false, busy = false, className }) {
  return <button type="button" aria-label={`Select all: ${section}`} onClick={onClick} disabled={disabled || busy}
    className={className || 'flex items-center justify-center gap-1.5 px-3 py-1.5 rounded-lg border border-slate-200 bg-white text-slate-600 font-semibold text-xs transition-all shadow-sm disabled:opacity-50'}>
    {busy ? 'Selecting…' : 'Select all'}
  </button>;
}
